import { from } from 'rxjs';
import { BaseModel } from '../../../shared/base/base.models';
import { Municipality } from '../municipalities/municipalities.models';

export class DeliveryZone extends BaseModel {
    name?: string;
    municipalities?: Municipality[]; 
}